import React from "react";
import "./styles.scss";
import Moment from "moment";
import Clock from "../images/Clock.png";

const SessionBox = (props) => {
  const [expanded, setExpanded] = React.useState(false);

  if (!props || !props.sessions || !props.activities) {
    return <p>Loading...</p>;
  }

  let active = {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "16px",
    color: "#0D8CC2",
    marginTop: "5px",
  };

  const Activity = (activity, type) => {
    const getConditionalText = () => {
      if (type === "Pre-Work") {
        let time = Moment(session.startTime).subtract(6, "days");
        // This is after the whole session has started and the live session
        if (Moment().isAfter(time) || props.sessions.isFirst) {
          return (
            <p style={active}>
              Complete by{" "}
              {Moment(session.startTime).format("MM/DD/YYYY hh:mm a")}
            </p>
          );
        }

        return (
          <p style={active}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="16"
              viewBox="0 0 12 16"
              fill="none"
            >
              <path
                d="M1.61535 16H9.44977C10.5321 16 11.0651 15.4669 11.0651 14.2877V8.23826C11.0651 7.17214 10.629 6.63099 9.72438 6.54215V4.5472C9.72438 1.47804 7.68097 0 5.53256 0C3.38415 0 1.34074 1.47804 1.34074 4.5472V6.56638C0.500757 6.69561 0 7.22867 0 8.23826V14.2877C0 15.4669 0.533064 16 1.61535 16ZM2.89147 4.40182C2.89147 2.51994 4.08682 1.48612 5.53256 1.48612C6.97022 1.48612 8.17365 2.51994 8.17365 4.40182V6.526L2.89147 6.53407V4.40182Z"
                fill="#0D8CC2"
              />
            </svg>{" "}
            Available to access at {time.format("MM/DD/YYYY hh:mm a")}
          </p>
        );
      }

      if (type === "In-Lesson") {
        // This is after the whole session has started and the live session
        if (Moment().isAfter(session.startTime)) {
          return (
            <p style={active}>
              Complete by{" "}
              {Moment(session.startTime).format("MM/DD/YYYY hh:mm a")}
            </p>
          );
        }

        return (
          <p style={active}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="16"
              viewBox="0 0 12 16"
              fill="none"
            >
              <path
                d="M1.61535 16H9.44977C10.5321 16 11.0651 15.4669 11.0651 14.2877V8.23826C11.0651 7.17214 10.629 6.63099 9.72438 6.54215V4.5472C9.72438 1.47804 7.68097 0 5.53256 0C3.38415 0 1.34074 1.47804 1.34074 4.5472V6.56638C0.500757 6.69561 0 7.22867 0 8.23826V14.2877C0 15.4669 0.533064 16 1.61535 16ZM2.89147 4.40182C2.89147 2.51994 4.08682 1.48612 5.53256 1.48612C6.97022 1.48612 8.17365 2.51994 8.17365 4.40182V6.526L2.89147 6.53407V4.40182Z"
                fill="#0D8CC2"
              />
            </svg>{" "}
            Available to access at{" "}
            {Moment(session.startTime).format("MM/DD/YYYY hh:mm a")}
          </p>
        );
      }

      if (type === "Post-Work") {
        if (Moment().isAfter(session.endTime)) {
          return <p style={active}>Complete after your session</p>;
        }

        return (
          <p style={active}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="16"
              viewBox="0 0 12 16"
              fill="none"
            >
              <path
                d="M1.61535 16H9.44977C10.5321 16 11.0651 15.4669 11.0651 14.2877V8.23826C11.0651 7.17214 10.629 6.63099 9.72438 6.54215V4.5472C9.72438 1.47804 7.68097 0 5.53256 0C3.38415 0 1.34074 1.47804 1.34074 4.5472V6.56638C0.500757 6.69561 0 7.22867 0 8.23826V14.2877C0 15.4669 0.533064 16 1.61535 16ZM2.89147 4.40182C2.89147 2.51994 4.08682 1.48612 5.53256 1.48612C6.97022 1.48612 8.17365 2.51994 8.17365 4.40182V6.526L2.89147 6.53407V4.40182Z"
                fill="#0D8CC2"
              />
            </svg>{" "}
            Available to access at{" "}
            {Moment(session.finish).format("MM/DD/YYYY hh:mm a")}
          </p>
        );
      }
    };

    const getActive = () => {
      if (type === "Pre-Work") {
        let time = Moment(session.start).subtract(6, "days");
        if (Moment().isAfter(time) || props.session.isFirst) {
          return true;
        }

        return false;
      }

      if (type === "Day-Of") {
        let time = Moment(session.start).subtract(9, "hours");
        if (Moment().isAfter(time)) {
          return true;
        }

        return false;
      }

      if (type === "In-Lesson") {
        if (
          Moment().isAfter(session.start) &&
          Moment().isBefore(Moment(session.finish))
        ) {
          return true;
        }

        return false;
      }

      if (type === "Post-Work") {
        if (Moment().isAfter(session.finish)) {
          return true;
        }

        return false;
      }
    };

    return (
      <div className="activity">
        <div className="info">
          <div className="title">
            <h3>
              {activity.name} <span>{activity.timeToComplete} minutes</span>
            </h3>
            <div className="description">
              <p>{activity.description}</p>
              <p>{getConditionalText()}</p>
            </div>
          </div>
          <div className="action">
            {getActive() && activity.linkType ==='INTERNAL' && <a href={activity.url}>View ></a>}
            {getActive() && activity.linkType ==='EXTERNAL' && <a href={activity.users[0].Activity_User.link}>View ></a>}

            {!getActive() && (
              <button
                style={{
                  opacity: ".4",
                }}
              >
                View >
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  const activities = props.activities.reduce(
    (acc, activity) => {
      if (activity.type === "IN-LESSON") {
        acc.inLesson.push(activity);
      } else if (activity.type === "PRE-WORK") {
        acc.preWork.push(activity);
      } else {
        acc.postWork.push(activity);
      }
      return acc;
    },
    {
      inLesson: [],
      preWork: [],
      postWork: [],
    }
  );

  let session = props.sessions;

  const getShowLive = (session) => {
    let time = Moment(session.startTime).subtract(10, "minutes");

    if (Moment().isAfter(time) && Moment().isBefore(Moment(session.endTime))) {
      return true;
    }

    return false;
  };

  return (
    <div className="sessionBox">
      <div className="top">
        <h2>{session.name}</h2>

        <p className="time">{Moment(session.startTime).format('MM/DD hh:mm a')}</p>
        <div className="info">
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M2.52082 15.3899H13.4872C14.3275 15.3899 14.9564 15.1825 15.3738 14.7677C15.7913 14.3529 16 13.7308 16 12.9012V3.09888C16 2.26931 15.7913 1.64713 15.3738 1.23235C14.9564 0.817561 14.3275 0.610168 13.4872 0.610168H2.52082C1.68055 0.610168 1.05034 0.817561 0.630206 1.23235C0.210069 1.64713 0 2.26931 0 3.09888V12.9012C0 13.7308 0.210069 14.3529 0.630206 14.7677C1.05034 15.1825 1.68055 15.3899 2.52082 15.3899ZM2.4004 14.0974C2.04716 14.0974 1.77421 14.0024 1.58154 13.8124C1.38886 13.6224 1.29253 13.3427 1.29253 12.9734V5.40294C1.29253 5.03365 1.38886 4.754 1.58154 4.564C1.77421 4.37401 2.04716 4.27901 2.4004 4.27901H13.5916C13.9502 4.27901 14.2258 4.37401 14.4185 4.564C14.6111 4.754 14.7074 5.03365 14.7074 5.40294V12.9734C14.7074 13.3427 14.6111 13.6224 14.4185 13.8124C14.2258 14.0024 13.9502 14.0974 13.5916 14.0974H2.4004ZM6.43853 7.16912H6.91219C7.05134 7.16912 7.14902 7.14236 7.20522 7.08884C7.26141 7.03532 7.28951 6.93898 7.28951 6.79983V6.32617C7.28951 6.18702 7.26141 6.09202 7.20522 6.04118C7.14902 5.99033 7.05134 5.9649 6.91219 5.9649H6.43853C6.29937 5.9649 6.2017 5.99033 6.14551 6.04118C6.08931 6.09202 6.06121 6.18702 6.06121 6.32617V6.79983C6.06121 6.93898 6.08931 7.03532 6.14551 7.08884C6.2017 7.14236 6.29937 7.16912 6.43853 7.16912ZM9.10384 7.16912H9.57752C9.72205 7.16912 9.82105 7.14236 9.87454 7.08884C9.92809 7.03532 9.95486 6.93898 9.95486 6.79983V6.32617C9.95486 6.18702 9.92809 6.09202 9.87454 6.04118C9.82105 5.99033 9.72205 5.9649 9.57752 5.9649H9.10384C8.96469 5.9649 8.86837 5.99033 8.81488 6.04118C8.76134 6.09202 8.73457 6.18702 8.73457 6.32617V6.79983C8.73457 6.93898 8.76134 7.03532 8.81488 7.08884C8.86837 7.14236 8.96469 7.16912 9.10384 7.16912ZM11.7772 7.16912H12.2429C12.3873 7.16912 12.4863 7.14236 12.5399 7.08884C12.5934 7.03532 12.6202 6.93898 12.6202 6.79983V6.32617C12.6202 6.18702 12.5934 6.09202 12.5399 6.04118C12.4863 5.99033 12.3873 5.9649 12.2429 5.9649H11.7772C11.6327 5.9649 11.5337 5.99033 11.4801 6.04118C11.4266 6.09202 11.3999 6.18702 11.3999 6.32617V6.79983C11.3999 6.93898 11.4266 7.03532 11.4801 7.08884C11.5337 7.14236 11.6327 7.16912 11.7772 7.16912ZM3.7732 9.7943H4.24687C4.38602 9.7943 4.48235 9.76756 4.53587 9.71407C4.58939 9.66052 4.61615 9.56418 4.61615 9.42503V8.9594C4.61615 8.81489 4.58939 8.71721 4.53587 8.66636C4.48235 8.61552 4.38602 8.59009 4.24687 8.59009H3.7732C3.6287 8.59009 3.52969 8.61552 3.47617 8.66636C3.42265 8.71721 3.39588 8.81489 3.39588 8.9594V9.42503C3.39588 9.56418 3.42265 9.66052 3.47617 9.71407C3.52969 9.76756 3.6287 9.7943 3.7732 9.7943ZM6.43853 9.7943H6.91219C7.05134 9.7943 7.14902 9.76756 7.20522 9.71407C7.26141 9.66052 7.28951 9.56418 7.28951 9.42503V8.9594C7.28951 8.81489 7.26141 8.71721 7.20522 8.66636C7.14902 8.61552 7.05134 8.59009 6.91219 8.59009H6.43853C6.29937 8.59009 6.2017 8.61552 6.14551 8.66636C6.08931 8.71721 6.06121 8.81489 6.06121 8.9594V9.42503C6.06121 9.56418 6.08931 9.66052 6.14551 9.71407C6.2017 9.76756 6.29937 9.7943 6.43853 9.7943ZM9.10384 9.7943H9.57752C9.72205 9.7943 9.82105 9.76756 9.87454 9.71407C9.92809 9.66052 9.95486 9.56418 9.95486 9.42503V8.9594C9.95486 8.81489 9.92809 8.71721 9.87454 8.66636C9.82105 8.61552 9.72205 8.59009 9.57752 8.59009H9.10384C8.96469 8.59009 8.86837 8.61552 8.81488 8.66636C8.76134 8.71721 8.73457 8.81489 8.73457 8.9594V9.42503C8.73457 9.56418 8.76134 9.66052 8.81488 9.71407C8.86837 9.76756 8.96469 9.7943 9.10384 9.7943ZM11.7772 9.7943H12.2429C12.3873 9.7943 12.4863 9.76756 12.5399 9.71407C12.5934 9.66052 12.6202 9.56418 12.6202 9.42503V8.9594C12.6202 8.81489 12.5934 8.71721 12.5399 8.66636C12.4863 8.61552 12.3873 8.59009 12.2429 8.59009H11.7772C11.6327 8.59009 11.5337 8.61552 11.4801 8.66636C11.4266 8.71721 11.3999 8.81489 11.3999 8.9594V9.42503C11.3999 9.56418 11.4266 9.66052 11.4801 9.71407C11.5337 9.76756 11.6327 9.7943 11.7772 9.7943ZM3.7732 12.4195H4.24687C4.38602 12.4195 4.48235 12.3941 4.53587 12.3432C4.58939 12.2924 4.61615 12.1947 4.61615 12.0502V11.5845C4.61615 11.4401 4.58939 11.3424 4.53587 11.2916C4.48235 11.2407 4.38602 11.2153 4.24687 11.2153H3.7732C3.6287 11.2153 3.52969 11.2407 3.47617 11.2916C3.42265 11.3424 3.39588 11.4401 3.39588 11.5845V12.0502C3.39588 12.1947 3.42265 12.2924 3.47617 12.3432C3.52969 12.3941 3.6287 12.4195 3.7732 12.4195ZM6.43853 12.4195H6.91219C7.05134 12.4195 7.14902 12.3941 7.20522 12.3432C7.26141 12.2924 7.28951 12.1947 7.28951 12.0502V11.5845C7.28951 11.4401 7.26141 11.3424 7.20522 11.2916C7.14902 11.2407 7.05134 11.2153 6.91219 11.2153H6.43853C6.29937 11.2153 6.2017 11.2407 6.14551 11.2916C6.08931 11.3424 6.06121 11.4401 6.06121 11.5845V12.0502C6.06121 12.1947 6.08931 12.2924 6.14551 12.3432C6.2017 12.3941 6.29937 12.4195 6.43853 12.4195ZM9.10384 12.4195H9.57752C9.72205 12.4195 9.82105 12.3941 9.87454 12.3432C9.92809 12.2924 9.95486 12.1947 9.95486 12.0502V11.5845C9.95486 11.4401 9.92809 11.3424 9.87454 11.2916C9.82105 11.2407 9.72205 11.2153 9.57752 11.2153H9.10384C8.96469 11.2153 8.86837 11.2407 8.81488 11.2916C8.76134 11.3424 8.73457 11.4401 8.73457 11.5845V12.0502C8.73457 12.1947 8.76134 12.2924 8.81488 12.3432C8.86837 12.3941 8.96469 12.4195 9.10384 12.4195Z"
                fill="#88D57B"
              />
            </svg>{" "}
            Live Session
          </p>
          <p>
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.5835 16C6.64789 16 6.72703 15.9879 6.82093 15.9638C6.91482 15.9396 7.01274 15.9007 7.11468 15.847C8.26293 15.2461 9.22471 14.7042 10 14.2213C10.7753 13.7384 11.395 13.2609 11.8591 12.7887C12.3233 12.3165 12.6573 11.8082 12.8612 11.2636C13.0651 10.719 13.167 10.0845 13.167 9.3602V3.29175C13.167 2.8786 13.0798 2.58082 12.9054 2.39839C12.7311 2.21596 12.4749 2.055 12.1368 1.91549C11.9491 1.83501 11.6915 1.73307 11.3642 1.60966C11.0369 1.48625 10.6761 1.35211 10.2817 1.20725C9.88732 1.06238 9.49294 0.917506 9.09856 0.772632C8.70423 0.627765 8.34475 0.497653 8.02012 0.382294C7.6955 0.266936 7.4393 0.177063 7.25151 0.112676C7.1442 0.080483 7.03421 0.0536554 6.92153 0.0321936C6.80885 0.0107312 6.69618 0 6.5835 0C6.47082 0 6.35949 0.0107312 6.2495 0.0321936C6.1395 0.0536554 6.03085 0.080483 5.92354 0.112676C5.73574 0.177063 5.4782 0.266936 5.1509 0.382294C4.82361 0.497653 4.46278 0.626425 4.06841 0.768611C3.67404 0.910797 3.27968 1.05567 2.88531 1.20322C2.49094 1.35077 2.13011 1.48759 1.80282 1.61368C1.47552 1.73977 1.21798 1.84037 1.03018 1.91549C0.697518 2.04963 0.442656 2.20925 0.265594 2.39437C0.0885313 2.57948 0 2.8786 0 3.29175V9.3602C0 10.0845 0.105969 10.7136 0.317907 11.2475C0.529845 11.7814 0.870557 12.2777 1.34004 12.7364C1.80953 13.1952 2.43192 13.6687 3.20724 14.157C3.98256 14.6452 4.93092 15.2085 6.05231 15.847C6.15426 15.9007 6.25218 15.9396 6.34608 15.9638C6.43997 15.9879 6.51911 16 6.5835 16ZM5.68209 11.6298C5.54258 11.6298 5.4165 11.6003 5.30382 11.5412C5.19115 11.4822 5.08115 11.3829 4.97385 11.2434L2.95372 8.76459C2.8947 8.68409 2.84775 8.59959 2.81288 8.51108C2.778 8.42257 2.76056 8.33268 2.76056 8.24142C2.76056 8.05901 2.82227 7.90208 2.94567 7.77063C3.06908 7.63917 3.222 7.57344 3.40443 7.57344C3.52247 7.57344 3.62843 7.59759 3.72233 7.64588C3.81623 7.69416 3.91415 7.78538 4.0161 7.91952L5.6499 10.0282L9.08652 4.50704C9.23674 4.26023 9.42989 4.13682 9.66598 4.13682C9.83768 4.13682 9.99328 4.19182 10.1328 4.30181C10.2723 4.41181 10.342 4.5607 10.342 4.74849C10.342 4.8397 10.3206 4.93092 10.2777 5.02213C10.2348 5.11335 10.1891 5.19919 10.1409 5.27967L6.35814 11.2434C6.2723 11.3722 6.17304 11.4688 6.06036 11.5332C5.94769 11.5976 5.8216 11.6298 5.68209 11.6298Z"
                fill="#88D57B"
              />
            </svg>
            {activities.preWork.length +
              activities.postWork.length +
              activities.inLesson.length}{" "}
            Tasks
          </p>
        </div>
        <p>{session.description}</p>

        {props.showExpand && (
          <div
            className="expand"
            onClick={() => {
              setExpanded(!expanded);
            }}
          >
            <p>View Details {expanded ? "⌃" : "⌄"}</p>
          </div>
        )}
      </div>

      {(expanded || !props.showExpand) && (
        <div className="filterBox">
          <div className="bottom">
            <div className="left">
              <h3>
                Group Coaching Session
                <span>
                  <img src={Clock} /> {session.length} Minutes
                </span>
              </h3>
              <p>{Moment(session.startTime).format("MM/DD/YYYY hh:mm a")}</p>
            </div>
            <div className="right">
              {!session.recording && getShowLive(session) && (
                <a
                  style={{
                    background: "#58c5f3",
                    color: "#ffffff",
                  }}
                  href={session.liveSessionUrl}
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="20"
                    viewBox="0 0 24 20"
                    fill="none"
                  >
                    <path
                      d="M2.61218 16.4031H21.3878C23.1041 16.4031 24 15.5356 24 13.791V2.90845C24 1.16385 23.1041 0.296265 21.3878 0.296265H2.61218C0.895874 0.296265 0 1.16385 0 2.90845V13.791C0 15.5356 0.895874 16.4031 2.61218 16.4031ZM9.62829 12.8102C9.13792 12.8102 8.74185 12.4424 8.74185 11.7729V4.91709C8.74185 4.24754 9.13792 3.88919 9.62829 3.88919C9.87348 3.88919 10.0809 3.96463 10.3167 4.08723L16.0031 7.43497C16.4275 7.68958 16.635 7.97249 16.635 8.34027C16.635 8.71748 16.4181 9.00982 16.0031 9.25501L10.3167 12.6027C10.0809 12.7348 9.87348 12.8102 9.62829 12.8102ZM7.17642 19.7037H16.8236C17.2951 19.7037 17.6817 19.3171 17.6817 18.8456C17.6817 18.3741 17.2951 17.978 16.8236 17.978H7.17642C6.70491 17.978 6.31827 18.3741 6.31827 18.8456C6.31827 19.3171 6.70491 19.7037 7.17642 19.7037Z"
                      fill="white"
                    />
                  </svg>
                  Join Video
                </a>
              )}

              {!session.recording && !getShowLive(session) && (
                <a
                  style={{
                    opacity: 1,
                  }}
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="20"
                    viewBox="0 0 24 20"
                    fill="none"
                  >
                    <path
                      d="M2.61218 16.4031H21.3878C23.1041 16.4031 24 15.5356 24 13.791V2.90845C24 1.16385 23.1041 0.296265 21.3878 0.296265H2.61218C0.895874 0.296265 0 1.16385 0 2.90845V13.791C0 15.5356 0.895874 16.4031 2.61218 16.4031ZM9.62829 12.8102C9.13792 12.8102 8.74185 12.4424 8.74185 11.7729V4.91709C8.74185 4.24754 9.13792 3.88919 9.62829 3.88919C9.87348 3.88919 10.0809 3.96463 10.3167 4.08723L16.0031 7.43497C16.4275 7.68958 16.635 7.97249 16.635 8.34027C16.635 8.71748 16.4181 9.00982 16.0031 9.25501L10.3167 12.6027C10.0809 12.7348 9.87348 12.8102 9.62829 12.8102ZM7.17642 19.7037H16.8236C17.2951 19.7037 17.6817 19.3171 17.6817 18.8456C17.6817 18.3741 17.2951 17.978 16.8236 17.978H7.17642C6.70491 17.978 6.31827 18.3741 6.31827 18.8456C6.31827 19.3171 6.70491 19.7037 7.17642 19.7037Z"
                      fill="white"
                    />
                  </svg>
                  Join Video
                </a>
              )}

              {session.recording && (
                <a
                  style={{
                    background: "#58c5f3",
                    color: "#ffffff",
                  }}
                  href={session.recording}
                  target="_blank"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="20"
                    viewBox="0 0 24 20"
                    fill="none"
                  >
                    <path
                      d="M2.61218 16.4031H21.3878C23.1041 16.4031 24 15.5356 24 13.791V2.90845C24 1.16385 23.1041 0.296265 21.3878 0.296265H2.61218C0.895874 0.296265 0 1.16385 0 2.90845V13.791C0 15.5356 0.895874 16.4031 2.61218 16.4031ZM9.62829 12.8102C9.13792 12.8102 8.74185 12.4424 8.74185 11.7729V4.91709C8.74185 4.24754 9.13792 3.88919 9.62829 3.88919C9.87348 3.88919 10.0809 3.96463 10.3167 4.08723L16.0031 7.43497C16.4275 7.68958 16.635 7.97249 16.635 8.34027C16.635 8.71748 16.4181 9.00982 16.0031 9.25501L10.3167 12.6027C10.0809 12.7348 9.87348 12.8102 9.62829 12.8102ZM7.17642 19.7037H16.8236C17.2951 19.7037 17.6817 19.3171 17.6817 18.8456C17.6817 18.3741 17.2951 17.978 16.8236 17.978H7.17642C6.70491 17.978 6.31827 18.3741 6.31827 18.8456C6.31827 19.3171 6.70491 19.7037 7.17642 19.7037Z"
                      fill="white"
                    />
                  </svg>
                  Replay
                </a>
              )}
            </div>
          </div>

          <div className="activities">
            {activities?.preWork.map((activity) => {
              return Activity(activity, "Pre-Work");
            })}
            {activities?.inLesson.map((activity) => {
              return Activity(activity, "In-Lesson");
            })}
            {activities?.postWork.map((activity) => {
              return Activity(activity, "Post-Work");
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default SessionBox;
